import Component from "../abstracts/Component";
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";
import vex from 'vex-js';

export default class CartComponent extends Component {
  get SELECTORS() {
    return {
      cart: '[data-cart-wrapper]',
      qtyBtn: '.js-qty',
      more: '.more',
      less: '.less',
      focusable: '[data-focus-id]',
      shippingRadios: '[data-shipping-method] input[type=radio]',
      shippingRadiosBox: '[data-shipping-method]',
      proceedBtn : '.js-click-and-collect-validation',
      errorMsg : '.js-click-and-collect-validation-error',
      options_checkbox_prefix: "shipping-",
      storeLocator: "[data-storelocator]",
      storeInput: ".sl__stores-list input[name='deliveryMethod']",
      storeRadio: "[data-store-name]",
      storeCard: ".store-card",
      cartAlertBox: "[data-jsnotification]",
      cartAlert: "[data-jsnotification] .cart-message", // cannot do with data-
      cartQtyUpdated: "[data-qty-updated-label]",
      passwordGroup: ".password-group",
      formLogin: ".login-wrapper form"
    };
  }

  get CLASSES() {
    return {
      checked: 'checked',
      active: 'active',
      inactive: 'inactive',
      lastItem: 'js-cart-remove-last',
      checked: "checked",
      active: "active",
      error: "error"
    };
  }

  constructor(compEl) {
    super(compEl);
    this.y = 0;
    this.quantityBoxes = this.$component.querySelectorAll(
      this.SELECTORS.qtyBtn
    );
    this.shippingRadios = this.$component.querySelectorAll(
      this.SELECTORS.shippingRadios
    );
    this.storeLocator = this.$component.querySelector(
      this.SELECTORS.storeLocator
    );
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000
    });
    this.cartAlert = this.$component.querySelector(this.SELECTORS.cartAlert);
    this.cartAlertBox = this.$component.querySelector(
      this.SELECTORS.cartAlertBox
    );
    this.cartQtyUpdated = this.$component.querySelector(
      this.SELECTORS.cartQtyUpdated
    );
    this.passwordGroup = this.$component.querySelector(
      this.SELECTORS.passwordGroup
    );
    this.formLogin = this.$component.querySelector(this.SELECTORS.formLogin);
  }

  quantityManager() {
    // update url
    let updateQtyUrl = document
      .querySelector(this.SELECTORS.cart)
      .getAttribute("data-update-qty-url");
    // quantity box looop

    this.quantityBoxes.forEach(quantityBox => {
      let addBtn = quantityBox.querySelector('.more');
      let removeBtn = quantityBox.querySelector('.less');
      let qty = quantityBox.querySelector('.qty');
      addBtn.addEventListener('click', () => {


        // set attribute data
        quantityBox.setAttribute('data-qty', parseInt(quantityBox.getAttribute('data-qty'),10) + 1);

        // save focus only for keyboard navigation
        if (window.__lastInteractionWasKeyboard) {
          const focusId = addBtn.dataset.focusId;

          if (focusId) sessionStorage.setItem('cartFocusId', focusId);
        }

        // go update quantity
        location.href =
          updateQtyUrl +
          "&entryNumber=" +
          quantityBox.getAttribute("data-entry-number") +
          "&qty=" +
          quantityBox.getAttribute("data-qty");
      });
      //
      removeBtn.addEventListener('click', (e) => {
        let btn = (e.target.localName === 'i') ? e.target.parentNode : e.target;
        if (parseInt(quantityBox.getAttribute('data-qty'), 10) > 0 &&
            !btn.classList.contains(this.CLASSES.lastItem) &&
            !btn.classList.contains(this.CLASSES.inactive)) {

          btn.classList.add(this.CLASSES.inactive);
          quantityBox.setAttribute('data-qty', parseInt(quantityBox.getAttribute('data-qty'), 10) - 1);

          // save focus only for keyboard navigation
          if (window.__lastInteractionWasKeyboard) {
            const focusId = btn.dataset.focusId;
            if (focusId) sessionStorage.setItem('cartFocusId', focusId);
          }

          location.href = updateQtyUrl + "&entryNumber=" + quantityBox.getAttribute('data-entry-number') + "&qty=" + quantityBox.getAttribute('data-qty');
        }
      });
    });
  }

  // show or hide store locator
  showOrHideStoreLocator(hide) {
    if (this.storeLocator !== null) {
      if (hide) {
        this.storeLocator.classList.add("d-none");
      } else {
        this.storeLocator.classList.remove("d-none");
      }
    }
  }

  //
  clickCollectStoreSelection(event) {
    // click collect select store
    this.$on(
      "click",
      ({ event }) => {
        // input clicked
        const input = event.currentTarget.parentElement.querySelector("input");
        //
        this.submitAjaxCartForm(input);
      },
      "body",
      this.SELECTORS.storeInput
    );
  }

  // update delivery method by input
  updateDeliveryMethod(event) {
    // input clicked
    let input = event.currentTarget.parentElement.querySelector("input");
    //
    this.submitAjaxCartForm(input);
  }

  // ajax call to update delivery method
  submitAjaxCartForm(input) {
    let deliveryMethod = input.value;
    let selectedStore = "";
    if (input.getAttribute("data-click-collect")) {
      selectedStore = input.getAttribute("id");
    }
    // go ajax
    fetch(
      `${
        document.location.href
      }?set-delivery-mode=updateDelivery&code=${deliveryMethod}&selectedStore=${selectedStore}`,
      {
        method: "GET",
        credentials: "include",
        mode: "cors"
      }
    ).then(res => {
      // console.log('[CartController]fetch done res:', res); i have no info about shipping price
    });
  }

  restoreFocus() {
    const focusId = sessionStorage.getItem('cartFocusId');
    if (!focusId) return;

    const candidates = [...document.querySelectorAll(`[data-focus-id="${focusId}"]`)];

    const focusTarget = candidates.find(el => el.offsetParent !== null);

    if (focusTarget) {

      focusTarget.focus();
      focusTarget.setAttribute("data-focused", "true");
      sessionStorage.removeItem('cartFocusId');
    }
  }


  bindEvents() {
    this.quantityManager();
    window.__lastInteractionWasKeyboard = false;

    document.addEventListener('keydown', (e) => {
      if (!['Shift', 'Alt', 'Meta', 'Control'].includes(e.key)) {
        window.__lastInteractionWasKeyboard = true;
      }
    });

    document.addEventListener('mousedown', () => {
      window.__lastInteractionWasKeyboard = false;
    });

    document.addEventListener('click', () => {
      const focusedElement = document.querySelector('[data-focused="true"]');
      if (focusedElement) {
        focusedElement.removeAttribute('data-focused');
      }
    });

    document.addEventListener('keydown', () => {
      const focusedElement = document.querySelector('[data-focused="true"]');
      if (focusedElement) {
        focusedElement.removeAttribute('data-focused');
      }
    });

    this.restoreFocus();

    // clicks on radio
    this.shippingRadios.forEach(checkbox => {
      // if is
      let isClickAndCollectCheckbox = checkbox.id.includes("Click-and-Collect");
      // listen to the click
      checkbox.addEventListener("change", event => {
        // hide/show store locator
        this.showOrHideStoreLocator(!isClickAndCollectCheckbox);
        // update delivery method if not click and collect
        this.updateDeliveryMethod(event);
        // change method class
        let checboxBoxChecked = document.querySelector(
          this.SELECTORS.shippingRadiosBox + "." + this.CLASSES.checked
        );
        let checboxBox = checkbox.closest(this.SELECTORS.shippingRadiosBox);
        // remove class from checked
        checboxBoxChecked.classList.remove(this.CLASSES.checked);
        // add class to selected
        checboxBox.classList.add(this.CLASSES.checked);
      });
    });

    // on show results
    this.$on(this.$customEvents.O2O.ccStoresShowResults, e => {
      // function to listen radio change
      this.clickCollectStoreSelection(e);
    });

    // click and collect selecting store
    this.$on(
      "click",
      ({ event }) => {
        // search parent li
        let radioBox = event.target.closest("li");
        // check if box is active
        if (radioBox.classList.contains(this.CLASSES.active)) {
          return;
        }
        // check click on more details
        if (
          event.target.className == "store-card__content__details__actions" ||
          event.target.className == "more" ||
          event.target.className == "js-less"
        )
          return;
        // remove active from actual active
        let storeChecked = document.querySelector(
          this.SELECTORS.storeCard + "." + this.CLASSES.active
        );
        if (storeChecked != null) {
          storeChecked.classList.remove(this.CLASSES.active);
        }
        // add active class
        radioBox.classList.add(this.CLASSES.active);
        // select radio in the box clicked if is not clicked on radio or label
        if (
          event.target.nodeName != "INPUT" &&
          event.target.nodeName != "LABEL"
        ) {
          let storeRadio = radioBox.querySelector(this.SELECTORS.storeRadio);
          storeRadio.click();
        }
      },
      "body",
      this.SELECTORS.storeCard
    );

    // Handler button modal delete-from-cart
    this.$on('click', ({event}) => {
      event.preventDefault();
      const button = event.currentTarget;
      const url = button.dataset.href;

      if (!url) return;

      window.location.href = url; // Vai direttamente all'URL

    }, 'body', '#delete-from-cart-modal button[data-href]');
  }

  cartAlerts() {
    // cart alerts
    if (this.cartAlert && this.cartAlertBox) {
      setTimeout(() => {
        this.liveRegion.sayMessage(this.cartAlertBox.textContent.trim());
      }, 5000);
    }
  }

  /**
   * Check for password errors on page load and announce them via live region
   * for accessibility purposes
   */
  checkPasswordErrorsOnLoad() {
    if (
      this.passwordGroup &&
      this.passwordGroup.classList.contains(this.CLASSES.error)
    ) {
      // Find the error message element
      const errorMessageEl = this.passwordGroup.querySelector(
        ".error.error-message"
      );

      if (errorMessageEl) {
        const errorMessage = errorMessageEl.textContent.trim();

        if (errorMessage) {
          // Announce the error message to screen readers
          this.liveRegion.sayMessage(errorMessage, 500);
          this.formLogin.querySelector('input[type="email"]').focus();
        }
      }
    }
  }

  render() {
    this.cartAlerts();
    this.bindEvents();
    this.checkPasswordErrorsOnLoad();
  }
}
